export const CATEGORIES_API = 'organizations-storage/categories';
export const CONTACTS_API = 'organizations-storage/contacts';
export const PRIVILEGED_CONTACT_URL = 'organizations-storage/privileged-contacts';
